<!--
 * @Description: 需要使用route中最外层name作为当前menu标识。children[0].name不再使用
 *               isOne 字段为只显示children第一个菜单，不展示children其他
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-03 09:41:19
-->

<template>
  <div class="aside-box aside-left" style="height: 100%">
    <el-menu
      :default-active="menuRouteName"
      :unique-opened="true"
      :router="false"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handSelect"
      :collapse="isCollapse"
    >
      <template v-for="(item, index) in aside.filter(i => !i.meta.hide)">
        <!-- 只展示一级菜单 -->
        <el-menu-item
          v-if="(item.children && item.children.length == 1) || item.meta.isOne"
          :index="item.name || item.children[0].name"
          :key="index"
          :class="[isActive(item) ? 'is-active' : '']"
        >
          <i class="el-icon-menu" v-show="isCollapse"></i>
          <img
            :src="[isActive(item) ? item.meta.activeIcon : item.meta.icon]"
            style="width:26px;height:26px;"
          />
          <span
            style="display: inline-block;text-align:left;margin-left: 12px;font-weight: 400;font-size: 16px"
            slot="title"
          >
            {{ item.children[0].meta.name }}
          </span>
        </el-menu-item>
        <el-submenu
          v-else
          :index="item.children[0].name"
          :key="index"
          popper-class="active-submenu"
        >
          <template slot="title">
            <img :src="item.meta.icon" style="width:26px;height:26px;" />
            <span style="display: inline-block;text-align:left" slot="title">
              {{ item.meta.name }}
            </span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(childrenItem, index2) in item.children"
              :key="index2 + 10"
              :index="childrenItem.name"
            >
              {{ childrenItem.meta.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { getStorage } from '@/tools/storage';
import * as routeObj from '@/router/index';

export default {
  name: 'Aside',
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aside: [],
      menuRouteName: '',
      userAuthData: {},
      change: false,
      activeIndex: '0'
    };
  },
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      projectType: state => state.homeProject.projectType
    })
  },
  methods: {
    ...mapMutations(['SET_PAGENUM']),
    handleOpen() {},
    handleClose() {},
    handSelect(key) {
      // qiankun: 子应用跳转
      // if (/v3-/.test(key)) {
      //   this.$router.push({
      //     name: key,
      //     query: {
      //       id: this.projectId,
      //       projectType: this.projectType
      //     }
      //   });
      //   return;
      // }
      if (this.projectId) {
        this.$router.push({
          name: key,
          query: {
            id: this.projectId,
            projectType: this.projectType
          }
        });
      } else {
        this.$router.push({
          name: key
        });
      }
      this.change = true;
      this.SET_PAGENUM(1);
    },
    async setAside() {
      // 子账号 黑名单
      const subAccountBlackList = [
        // '电子合同',
        // '项目入驻',
        '项目退出',
        '退出结算',
        '概要'
      ];
      this.getStorage = getStorage('userAuthData');
      let noRiskList = [7];
      let isShowRisk = noRiskList.includes(this.projectType);
      let path = this.$route;
      this.aside = [...routeObj[path.meta.asideName]];
      if (!this.$store.getters.isMaster) {
        this.aside = this.aside.filter(i => {
          return !subAccountBlackList.includes(i.meta.name);
        });
      }

      if (isShowRisk && path.meta.asideName == 'projectAsideList') {
        //如果不是指定项目类型 则去掉风控入口
        this.aside.filter((item, index) => {
          if (/risk/.test(item.path)) {
            this.aside.splice(index, 1);
          }
        });
      }

      for (let i = 0; i < this.aside.length; i++) {
        const item = this.aside[i];
        try {
          if (item.meta.checkShow) {
            const show = await item.meta.checkShow();
            item.meta.hide = !show;
          }
        } catch (error) {
          console.warn('run aside checkShow err');
        }
      }
    },
    // 之后使用currentRoute.name。currentRoute.children[0].name为兼容之前
    isActive(currentRoute) {
      return [currentRoute.children[0].name, currentRoute.name].includes(
        this.menuRouteName
      );
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        let { name, matched } = v;
        // 优先使用matched[0].name，如果有二级子页面如编辑页面，保证aside也处于激活。
        this.menuRouteName = matched[0].name || name;
        this.setAside();
      }
    }
  },
  created() {}
};
</script>
<style></style>
<style lang="scss">
@import '~@/styles/theme.scss';
.aside-left {
  z-index: 2;
  /*aside 激活背景色*/
  .el-menu-item.is-active {
    background: #e4f1ff !important;
    position: relative;
  }

  .el-menu-item.is-active:before {
    content: '';
    width: 4px;
    height: 30px;
    background: $--color-primary;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .el-menu-vertical-demo * {
    font-size: 1em;
    font-weight: 400;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  .el-menu-item span {
    padding-left: 18px;
  }

  .el-submenu__title span {
    padding-left: 18px;
  }

  .el-submenu .el-menu-item {
    min-width: auto !important;
  }
}

.el-menu {
  border-right-color: #fff !important;
}
</style>
